import { useEffect, useMemo } from 'react';
import jwtDecode from 'jwt-decode';
import List from '@mui/material/List';
import { Box, styled } from '@mui/material';
import { useDispatch } from 'react-redux';
import { getCustomFilterViewList } from '../../features/CustomFilterView/customFilterViewAction';
import AppMenuItem from './AppMenuItem';
import useAppMenu from './useAppMenu';
import { getLocalStorage } from '../../utils/methods';

const AppList = styled(List)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.mainColor,
}));

function AppMenu({
  handleDrawerOpen, isDrawerOpen, permissions, clickedOutside,
}) {
  const {
    open,
    setOpen,
    handleClick,
    bottomMenuItems,
    appMenuItems,
    tenantMenu,
  } = useAppMenu({ permissions });

  const dispatch = useDispatch();
  const idToken = getLocalStorage('idToken');

  const isSalesforce = useMemo(() => {
    const decode = idToken ? jwtDecode(idToken) : null;
    return decode?.salesforce ?? false;
  }, [idToken]);

  useEffect(() => {
    dispatch(getCustomFilterViewList());
  }, []);

  useEffect(() => {
    if (!isDrawerOpen) setOpen(null);
  }, [isDrawerOpen]);

  return (
    <AppList
      component="nav"
      disablePadding
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        flexDirection: 'column',
      }}
    >
      <Box>
        {permissions?.manage && tenantMenu?.map((item, index) => (
          <AppMenuItem
            {...item}
            key={index}
            index={index}
            open={open}
            setOpen={setOpen}
            isDrawerOpen={isDrawerOpen}
            handleDrawerOpen={handleDrawerOpen}
            handleClick={(...args) => handleClick(...args)}
            clickedOutside={clickedOutside}
            permissions={permissions}
          />
        ))}

        {!permissions?.manage && appMenuItems?.map((item, index) => (!item.permission || permissions[item.permission])
          && (
          <AppMenuItem
            {...item}
            key={index}
            rowIndex={`appMenu-${index}`}
            open={open}
            setOpen={setOpen}
            handleDrawerOpen={handleDrawerOpen}
            isDrawerOpen={isDrawerOpen}
            handleClick={handleClick}
            clickedOutside={clickedOutside}
          />
          ))}
      </Box>
      {!isSalesforce
        ? (
          <Box>
            {bottomMenuItems?.map((item, index) => (
              (!item.permission || permissions[item.permission]) && (
              <AppMenuItem
                {...item}
                key={index}
                rowIndex={index}
                open={open}
                setOpen={setOpen}
                handleDrawerOpen={handleDrawerOpen}
                isDrawerOpen={isDrawerOpen}
                handleClick={item.onClick ?? handleClick}
                clickedOutside={clickedOutside}
              />
              )
            ))}
          </Box>
        )
        : null }
    </AppList>
  );
}

export default AppMenu;
